import { createSelector } from "reselect";

import auditLogEntities from "./audit-log-entities";
import changesetEntities from "./changesets";

const auditLogs = {};

/**
 * Returns all audit logs.
 * @param {Object} state
 * @returns {Object[]} audit logs
 */
auditLogs.get = state => state.auditLogs.items;

/**
 * Returns all audit logs with hydrated actor, target and changeset details.
 * @param {Object} state
 * @returns {Object[]} audit logs
 */
auditLogs.getHydrated = createSelector(
  [auditLogs.get, auditLogEntities.get, changesetEntities.get],
  (logs, entities, changesets) =>
    logs.map(log => {
      const hydrated = { ...log };
      if (log.actor) {
        hydrated.actor = entities.find(
          entity => log.actor.$ref === entity.$uri
        );
      }
      if (log.target) {
        hydrated.target = entities.find(
          entity => log.target.$ref === entity.$uri
        );
      }
      if (log.changeset) {
        hydrated.changeset = changesets.find(
          changeset => log.changeset.$ref === changeset.$uri
        );
      }
      return hydrated;
    })
);

export default auditLogs;
